// extracted by mini-css-extract-plugin
export var footer = "_qt-0";
export var inherit = "_qt-1";
export var input = "_qt-2";
export var modalContent = "_qt-3";
export var quillEditor = "_qt-4";
export var subtitle = "_qt-5";